module.exports = __webpack_public_path__ + "87cb90d6644b7414c6033c5075043017.svg";